import NetworkingOperations from "../index";

const PaypalLoginInit = (data) => {
	const url = process.env.REACT_APP_PAYPAL_LOGIN_INIT;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaypalLoginInit;
